import React, {Component} from 'react'
import {connect} from 'react-redux'
import Intro from './Intro'
import Final from './Final'
import Slides from './Slides'
import { fetchPage } from './../../../../services/ApiController'
import { QuizzContainerStyle } from './../../../../styles'

class Quizz extends Component {
  state = {
    intro: true,
    slides: false,
    final: false,
    isReady: false,
    finalResult: {}
  }

  componentDidMount() {
    document.body.classList.add('nofooter')
    this.getData()
  }


  componentWillUnmount() {
    document.body.classList.remove('nofooter')
  }

  componentWillReceiveProps({data}){
    if(data !== this.props.data){
      this.setState({ 
        isReady: false,
        intro: true,
        slides: false,
        final: false,
        isReady: false,
        finalResult: {}
      })
      this.getData()
    }
  }

  getData = async() => {
    await fetchPage(this.props.match.params.slug === 'current' ? `/challenge/quiz` : `/challenge/quiz/${this.props.match.params.slug}`).then((data) => {
      this.setState({
        data,
        isReady: true
      })
    }).catch((e) => {
      console.log('Ooops something wrong with Question')
    })
  }


  handlerStart = () => {
    this.setState({ intro: false, slides: true })
  }

  handlerFinal = (data) => {
    this.setState({ slides: false, final: true, finalResult: data})
  }

  render () {
    const {intro, slides, final, data, isReady, finalResult} = this.state
    const {username} = this.props
    return (
      <div className={` quizz ${QuizzContainerStyle(isReady)}`}>

       {
         intro && <Intro {...data} startQuizz={this.handlerStart} />
       } 
       {
         slides && data && !final && <Slides id={this.props.match.params.slug} current={data.current} getFinal={this.handlerFinal} />
       }
       {
         final && <Final id={this.props.match.params.slug} name={username} current={data.current} alreadyPlayed={data.alreadyPlayed} result={finalResult} />
       } 
      </div>
    )
  }
}

export default connect(
  ({Session}) => ({
    username: Session.username
  })
)(Quizz)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Quizz/index.js